module.exports = __webpack_public_path__ + "img/zhuimeng.969baa1.png";